import useGetCompanySkillList from '~hooks/query/review/useGetCompanySkillList';
import { useRouterQuery } from '~hooks/useRouterQuery';
import { isEmpty } from '~utils/lodash';

import * as S from './style';

function SkillList() {
  const companyHash = useRouterQuery('companyId');
  const { data } = useGetCompanySkillList(companyHash);

  return (
    <S.Wrapper>
      {isEmpty(data?.skills) ? (
        <S.NoData>아직 등록된 기술&툴 정보가 없습니다</S.NoData>
      ) : (
        <S.ItemList>
          {data?.skills?.map((item) => (
            <S.Item key={item.id}>{item.title}</S.Item>
          ))}
        </S.ItemList>
      )}
    </S.Wrapper>
  );
}

export default SkillList;
